<div
  class="footer-container"
  [ngStyle]="{
    padding: userService.isAuthenticated() && isMobile ? '0px' : '16px 18px'
  }"
>
  @if (footerDisplayed) { @if (userService.isAuthenticated()) { @if (isMobile) {
  <div class="footer-user">
    @if (currentEvent | async; as event) {
      @if (event?.isSchedulePublic) {
        <div
          class="footer-item"
          [routerLinkActiveOptions]="{ exact: false }"
          routerLink="/schedule/all"
          routerLinkActive="item-active"
          #rlaSchedule="routerLinkActive"
        >
          <img
            class="footer-item-icon"
            [src]="
              rlaSchedule.isActive
                ? 'assets/imgs/schedule-active.svg'
                : 'assets/imgs/schedule.svg'
            "
            alt="schedule"
          />
          <div class="footer-schedule-title">EXPLORE</div>
        </div>
      }
    }
    <div
      class="footer-item"
      [routerLinkActiveOptions]="{ exact: false }"
      routerLink="/profile/rsvp"
      #rlaRSVP="routerLinkActive"
      routerLinkActive="item-active"
    >
      <img
        class="footer-item-icon"
        [src]="
          rlaRSVP.isActive
            ? 'assets/imgs/RSVP-active.svg'
            : 'assets/imgs/RSVP.svg'
        "
        alt="schedule"
      />
      <div class="footer-schedule-title">MY SHCEDULES</div>
    </div>
    <!-- <div
      class="footer-item"
      [routerLinkActiveOptions]="{ exact: true }"
      routerLink="/profile/members"
      #rlaMembers="routerLinkActive"
      routerLinkActive="item-active"
    >
      <img
        class="footer-item-icon"
        [src]="
          rlaMembers.isActive
            ? 'assets/imgs/members-active.svg'
            : 'assets/imgs/members.svg'
        "
        alt="schedule"
      />
      <div class="footer-schedule-title">ATTENDEES</div>
    </div> -->
    <!-- if user is industry, show industry meetups and invites -->
    @if (user | async; as userData) {
      @if (userData?.status === 'industry') {
        <div class="footer-item" [routerLinkActiveOptions]="{ exact: false }" routerLink="/profile/industry-meetups" routerLinkActive="item-active" #rlaIndustryMeetups="routerLinkActive">
          <img class="footer-item-icon" [src]="rlaIndustryMeetups.isActive ? 'assets/imgs/schedule-icon-active.svg' : 'assets/imgs/schedule-icon.svg'" alt="industry-meetups" />
          <div class="footer-schedule-title">INDUSTRY MEETUPS</div>
        </div>
      }
    }
<div
      class="footer-item"
      routerLink="/profile/details"
      #rlaProfile="routerLinkActive"
      routerLinkActive="item-active"
      [routerLinkActiveOptions]="{ exact: false }"
    >
      <img
        class="footer-item-icon"
        [src]="
          rlaProfile.isActive
            ? 'assets/imgs/profile-active.svg'
            : 'assets/imgs/profile.svg'
        "
        alt="schedule"
      />
      <div class="footer-schedule-title">PROFILE</div>
    </div>
  </div>

  } @else {
  <div class="footer-socials">
    <a [href]="'https://www.instagram.com/wirefestival/'" target="_blank">
      <img src="assets/imgs/instagram.svg" alt="instagram" />
    </a>
    <div [routerLink]="['tickets']" routerLinkActive="router-link-active">
      <img src="assets/imgs/tickets.svg" alt="tickets" />
      TICKETS
    </div>
    <a class="footer-socials-story" href="https://shop.wirefestival.com/" target="_blank">
      <img src="assets/imgs/story.svg" alt="story" />
      STORE
    </a>
  </div>
  <a
    class="footer-address-link"
    target="_blank"
    href="https://www.google.com/maps/place/Knockdown+Center/@40.7157764,-73.9144982,716m/data=!3m1!1e3!4m6!3m5!1s0x89c25ea2cb53d0a9:0xe6dd93729a094800!8m2!3d40.7157764!4d-73.9144982!16s%2Fg%2F1hm2tr553?entry=tts&g_ep=EgoyMDI1MDQwNy4wIPu8ASoJLDEwMjExNjQwSAFQAw%3D%3D&skid=a6668d5b-631b-41ed-aea4-f6a314da871e"
  >
    <!-- <div class="footer-address">KNOCKDOWN CENTER, NY</div> -->
  </a>

  } } @else {

  <div class="footer-socials">
    <a [href]="'https://www.instagram.com/wirefestival/'" target="_blank">
      <img src="assets/imgs/instagram.svg" alt="facebook" />
    </a>
    <!-- <div [routerLink]="['tickets']" routerLinkActive="active">
      <img src="assets/imgs/ra.svg" alt="ra" />
    </div> -->
  </div>
  <a
    class="footer-address-link"
    target="_blank"
    href="https://www.google.com/maps/place/Knockdown+Center/@40.7157764,-73.9144982,716m/data=!3m1!1e3!4m6!3m5!1s0x89c25ea2cb53d0a9:0xe6dd93729a094800!8m2!3d40.7157764!4d-73.9144982!16s%2Fg%2F1hm2tr553?entry=tts&g_ep=EgoyMDI1MDQwNy4wIPu8ASoJLDEwMjExNjQwSAFQAw%3D%3D&skid=a6668d5b-631b-41ed-aea4-f6a314da871e"
  >
    <!-- <div class="footer-address">KNOCKDOWN CENTER, NY</div> -->
  </a>
  <div
    class="footer-login"
    [routerLink]="['/login']"
    routerLinkActive="router-link-active"
  >
    LOGIN
  </div>
  } }
</div>
